import { produce } from 'immer'
import moment from 'moment'
import { REHYDRATE } from 'redux-persist'

import * as types from './datepicker-header-constants'

const periodDefault = {
  sevenDays: {
    startDate: moment().subtract(7, 'days'),
    endDate: moment()
  }
}

const INITIAL_STATE = {
  startDate: periodDefault.sevenDays.startDate,
  endDate: periodDefault.sevenDays.endDate,
  compareStartDate: null,
  compareEndDate: null
}

export default function datepickerHeader(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case types.DATEPICKER_HEADER_SET_DATES:
        draft.startDate = action.startDate
        draft.endDate = action.endDate

        if (draft.compareStartDate) {
          const startDate = draft.startDate
          const endDate = draft.endDate

          const range = endDate.diff(startDate, 'days')

          const compareStartDate = draft.compareStartDate
          const compareEndDate = compareStartDate.clone().add(range, 'days')

          draft.compareStartDate = compareStartDate
          draft.compareEndDate = compareEndDate
        }

        break

      case types.DATEPICKER_COMPARE_SET_DATE: {
        if (!action.compareStartDate) {
          draft.compareStartDate = null
          draft.compareEndDate = null

          break
        }

        const startDate = draft.startDate
        const endDate = draft.endDate

        const range = endDate.diff(startDate, 'days')

        const compareStartDate = action.compareStartDate
        const compareEndDate = compareStartDate.clone().add(range, 'days')

        draft.compareStartDate = compareStartDate
        draft.compareEndDate = compareEndDate

        break
      }

      case REHYDRATE: {
        if (action?.payload?.datepickerHeader) {
          const { startDate, endDate } = action.payload.datepickerHeader

          if (startDate) {
            draft.startDate = moment(startDate)
          }

          if (endDate) {
            draft.endDate = moment(endDate)
          }

          if (action.payload.datepickerHeader.compareStartDate) {
            draft.compareStartDate = moment(
              action.payload.datepickerHeader.compareStartDate
            )
          }

          if (action.payload.datepickerHeader.compareEndDate) {
            draft.compareEndDate = moment(
              action.payload.datepickerHeader.compareEndDate
            )
          }
        }

        break
      }

      default:
        return state
    }
  })
}
